﻿import { ColumnsBase, fieldsProxy } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";
import { DataType } from "./DataType";

export interface SqlProcLookupParametersColumns {
    Name: Column;
    Title: Column;
    Type: Column;
    Required: Column;
    Size: Column;
    Scale: Column;
    Value: Column;
}

export class SqlProcLookupParametersColumns extends ColumnsBase {
    static readonly columnsKey = 'Common.SqlProcLookupParameters';
    static readonly Fields = fieldsProxy<SqlProcLookupParametersColumns>();
}

[DataType]; // referenced types